<template>
  <div id="app">
    <Header/>
    <div class="container">
      <router-view></router-view>
      <br>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "./views/layout/Header";
import Footer from "./views/layout/Footer";

export default {
  components: {
    Header,
    Footer
  },
  created() {
    this.$store.dispatch("tryAutoLogin");
  }
};
</script>

<style>
/* body {
  padding-top: 30px;
  padding-left: 60px;
} */

/* @font-face {
  font-family: "Ubuntu";
  src: url("./assets/Fonts/Ubuntu-R.ttf") format("truetype");
} */

@font-face {
  font-family: "Ubuntu";
  font-display: auto;
  src: local("Ubuntu"), url("./assets/Fonts/Ubuntu-R.ttf") format("truetype");
}

.ubuntu {
  font-family: "Ubuntu", sans-serif;
}

.corered {
  color: #ff0404;
}

.coreblue {
  color: #0000ff;
}

.link-override {
  color: rgba(0, 0, 0, 0.5);
  text-decoration: None;
}
</style>
